export const STANDS = {
    boisson: { label: 'Stand Boissons', shortLabel: 'Boissons' },
    repas: { label: 'Stand Repas', shortLabel: 'Repas' },
    dessert: { label: 'Stand Desserts', shortLabel: 'Desserts' },
    artisan: { label: 'Artisans / Tracteurs', shortLabel: 'Artisans' },
};

export const STAND_ORDER = ['boisson', 'repas', 'dessert', 'artisan'];

export const STAND_OPTIONS = STAND_ORDER.map((value) => ({
    value,
    label: STANDS[value].shortLabel,
}));
